export default {
    title: 'Domains',
    details: {
        title: 'Domain',
        domainTechnologies: 'Domain Technologies',
        domainHistory: 'Domain History',
    },
    layout: {
        technologiesTab: 'Technologies',
        historyTab: 'History',
    },
    link: {
        openInNewTab: 'Open in New Tab',
    },
    table: {
        domain: 'Domain',
        country: 'Country',
        technologyCount: 'Technology Count',
        company: 'Company',
    },
    corporations: {
        title: 'About company',
        corporateNumber: 'Corporate number',
        companyPage: 'Company Page',
        more: (count: number) => `+${count} more`,
    },
};
